import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { usePagination } from '@frontend/features/common/components/Table';
import { Link } from '@frontend/features/common/components/Link';
import { ListLayout } from '@frontend/features/common/components/ListLayout';

import { routes } from '../routes';
import { ListContentLayout } from '@frontend/features/common/components/ListContentLayout';
import { CreateFieldBlockModal } from '@frontend/features/custom-fields/components/CreateFieldBlockModal';
import { useGetFieldBlocksByAgency } from '@frontend/features/custom-fields/queries';
import { EditFieldBlockModal } from '@frontend/features/custom-fields/components/EditFieldBlockModal';
import { TABLE_HEIGHT_WITH_AGENCIES_LAYOUT } from '@frontend/features/agencies/constants';

export const CustomFields = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const pagination = usePagination();
  const [search, setSearch] = useState('');
  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [editId, setEditId] = useState<string | undefined>();
  const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);

  const toggleCreateModal = () => setIsOpenCreate((prevState) => !prevState);
  const handleOpenEditModal = (id: string) => {
    setEditId(id);
    setIsOpenEdit(true);
  };

  const handleCloseEditModal = () => {
    setEditId(undefined);
    setIsOpenEdit(false);
  };

  const { data, isLoading } = useGetFieldBlocksByAgency({
    pageSize: pagination.rowsPerPage,
    currentPage: pagination.page,
    search: search,
    agencyId: id,
  });

  const handleOnSearch = (value: string) => {
    setSearch(value);
  };

  return (
    <ListLayout padding={0} title={t('customFields.title')} subtitle={t('customFields.subtitle')}>
      {id && <CreateFieldBlockModal agencyId={id} open={isOpenCreate} onClose={toggleCreateModal} />}
      {id && editId && (
        <EditFieldBlockModal agencyId={id} open={isOpenEdit} fieldBlockId={editId} onClose={handleCloseEditModal} />
      )}

      <ListContentLayout
        height={TABLE_HEIGHT_WITH_AGENCIES_LAYOUT}
        stickyHeader
        onSearchChange={handleOnSearch}
        onCreate={toggleCreateModal}
        columns={[
          {
            id: 'name',
            label: t('teams.table.name'),
            align: 'left',
          }
        ]}
        isLoading={isLoading}
        data={
          data && {
            key: 'id',
            items: data.items.map((item) => ({
              ...item,
              name: (
                <Link
                  to={`${routes.dashboard.agencyView.root.replace(
                    ':id',
                    String(id),
                  )}/${routes.dashboard.agencyView.customFieldsView.replace(':fieldBlockId', String(item.id))}`}
                >
                  {item.name}
                </Link>
              ),
            })),
            totalCount: data.count,
          }
        }
      />

    </ListLayout>
  );
};
